import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import { LinkButton, PrimaryButton } from "components/buttons";
import rize_logo from "assets/images/rize_logo.svg";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import alrajhi247 from "assets/images/alrajhi247.png";
import alrajhicashbiz247 from "assets/images/alrajhicashbiz247.png";
import "../personal/personal.css";
import "./digitalBanking.css";
import { useNavigate } from "react-router-dom";

function DigitalBankingOverview() {
  const navigate = useNavigate();
  const handleDownload = (url) => window.open(url);

  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Digital"
          title={`<span className="jumbotron-subtitle-2">Manage your money</span><br/>anytime, anywhere`}
        />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col>
              <div className="digital-banking-items my-3 shadow-sm">
                <div className="">
                <div className="header mb-5 mt-3">
                    <span>Coming </span>Soon
                  </div>
                  <div className="d-flex flex-row gap-3">
                    <LinkButton
                      text="Learn more"
                      onClick={() => navigate("/coming-soon")}
                    />
                  </div>
                </div>
                <div className="">
                  <img
                    src={alrajhi_logo}
                    alt="alrajhi_logo"
                    width="250vh"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="digital-banking-items my-3 shadow-sm">
                <div className="">
                  <div className="header mb-5">Rize</div>
                  <div className="d-flex flex-row gap-3">
                    <PrimaryButton
                      text="Download App"
                      onClick={() => handleDownload("https://rize.com.my/")}
                    />
                    <LinkButton
                      text="Learn more"
                      onClick={() => navigate("/rize/personal")}
                    />
                  </div>
                </div>
                <div className="">
                  <img
                    src={`https://www.alrajhibank.com.my/assets/images/gallery/new_rize_logo.svg`}
                    alt="rize_logo"
                    width="200vh"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="digital-banking-items my-3 shadow-sm">
                <div className="">
                  <div className="header mb-5">
                    <span>alrajhi</span>@24seven
                    <div className="sub-header">(Personal)</div>
                  </div>
                  <div className="d-flex flex-row gap-3">
                    <PrimaryButton
                      text="Login"
                      onClick={() =>
                        handleDownload(
                          "https://www.alrajhi24seven.com.my/iportalweb/iRetail@1"
                        )
                      }
                    />
                    <LinkButton
                      text="Learn more"
                      onClick={() => navigate("/digital/alrajhi-24seven")}
                    />
                  </div>
                </div>
                <div className="">
                  <img src={alrajhi247} alt="rize_logo" width="300px" />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="digital-banking-items my-3 shadow-sm">
                <div className="">
                  <div className="header mb-5">
                    <span>alrajhi </span>cashbiz@24seven
                    <div className="small-header">Cash Management Business</div>
                    <div className="sub-header">(Business)</div>
                  </div>
                  <div className="d-flex flex-row gap-3">
                    <PrimaryButton
                      text="Login"
                      onClick={() =>
                        handleDownload(
                          "https://www.alrajhicashbiz24seven.com.my/iportalweb/CBXLogin.jsp"
                        )
                      }
                    />
                    <LinkButton
                      text="Learn more"
                      onClick={() =>
                        navigate("/business/cash-management/alrajhi-cashbiz")
                      }
                    />
                  </div>
                </div>
                <div className="">
                  <img src={alrajhicashbiz247} alt="rize_logo" width="350px" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default DigitalBankingOverview;
